import React from "react";
import { Dropdown, Button } from "antd";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const DropdownBtn = () => {
  const navigate = useNavigate();

  const items = [
    {
      key: "2",
      label: "Create Enquiry",
      onClick: () => navigate("/enquiry"),
    },
    {
      key: "1",
      label: "Create Quotation",
      onClick: () => navigate("/quotation/create"),
    },
    
    {
      key: "3",
      label: "Create Invoice",
      onClick: () => navigate("/invoice/create"),
    },
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight" arrow>
      <Button type="primary" icon={<PlusOutlined />} size="large">
        Create <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default DropdownBtn;

